// @flow
import * as React from 'react';
import styled from 'styled-components';
import Link from 'components/Link';
import Box from 'components/Box';
import Icon from 'components/Icon';
import { FilestackImage } from 'components/Image';
import NoAmp from 'containers/NoAmp';
import { connect } from 'react-redux';
import type { ImageWithTextData } from 'api/shared';
import { colors } from '../theme';
import { showModal } from '../redux/main/actions/modal';

const List = styled.ul`
  display: flex;
  margin: -4px;
  flex-wrap: wrap;
  list-style-type: none;
  padding-left: 0;
  color: ${colors.greyishBrown};
  img {
    width: 100%;
    height: auto;
  }
  @media print {
    li {
      max-width: 100px;
    }
  }
`;

const MediaLink = styled(Link)`
  max-width: 100%;
`;

type OwnProps = {
  items: Array<ImageWithTextData>
};

type Props = {
  ...$Exact<OwnProps>,
  showModal: typeof showModal
};

type State = {
  showAll: boolean
};

class MediaGalleryContainer extends React.Component<Props, State> {
  state = {
    showAll: false
  };

  setShowAll = (showAll: boolean) => {
    this.setState({ showAll });
  };

  showModal = (itemIndex: number) => {
    this.props.showModal('MEDIA_GALLERY', {
      items: this.props.items,
      itemIndex
    });
  };

  render() {
    const items = this.state.showAll
      ? this.props.items
      : this.props.items.slice(0, 4);
    return (
      <>
        <List>
          {items.map((item, index) => (
            <Box
              width={[1 / 2, 1 / 3, 1 / 4]}
              p="4px"
              key={item.fileId}
              component="li"
            >
              <MediaLink
                href="#"
                onClick={ev => {
                  ev.preventDefault();
                  this.showModal(index);
                }}
                data-qa-id="media-item"
              >
                <Box pb="100%" position="relative">
                  <Box position="absolute" width={1} top={0} left={0}>
                    <FilestackImage
                      data={item}
                      alt={item.altText || ''}
                      width={164}
                      height={164}
                      fit="crop"
                    />
                  </Box>
                </Box>
              </MediaLink>
            </Box>
          ))}
        </List>
        <NoAmp>
          {this.props.items.length > 4 && (
            <Box mt={12} display="flex" alignItems="center">
              <Box width="16px" mr="6px">
                <Icon name="photo" fill={colors.greyishBrown} />
              </Box>
              {this.state.showAll ? (
                <Link
                  href="#"
                  onClick={ev => {
                    ev.preventDefault();
                    this.setShowAll(false);
                  }}
                  data-qa-id="view-less-photos"
                >
                  {getText('View fewer photos')}
                </Link>
              ) : (
                <Link
                  href="#"
                  onClick={ev => {
                    ev.preventDefault();
                    this.setShowAll(true);
                  }}
                  data-qa-id="view-more-photos"
                >
                  {getText('View more photos')}
                </Link>
              )}
            </Box>
          )}
        </NoAmp>
      </>
    );
  }
}

export default connect<Props, OwnProps, _, _, _, _>(
  null,
  { showModal }
)(MediaGalleryContainer);
